import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#58C6F5',
      light: '#7dd4f7',
      dark: '#3d8aac',
      contrastText: '#fff',
    },
    secondary: {
      main: '#757575',
      light: '#a4a4a4',
      dark: '#494949',
      contrastText: '#fff',
    },
    background: {
      default: '#ffffff',
      paper: '#f5f5f5',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: '2.5rem',
      fontWeight: 500,
      fontFamily: '"Handsean", cursive',
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 500,
      fontFamily: '"Handsean", cursive',
    },
    h3: {
      fontSize: '1.75rem',
      fontWeight: 500,
      fontFamily: '"Handsean", cursive',
    },
    h4: {
      fontSize: '1.5rem',
      fontWeight: 500,
      fontFamily: '"Handsean", cursive',
    },
    h5: {
      fontSize: '1.25rem',
      fontWeight: 500,
      fontFamily: '"Handsean", cursive',
    },
    h6: {
      fontSize: '1rem',
      fontWeight: 500,
      fontFamily: '"Handsean", cursive',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        },
      },
    },
  },
});

export default theme;
